import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

let cachedCommodities = null;
let commoditiesPromise = null;

const GetCommOpt = () => {
  const [options, setOptions] = useState(cachedCommodities || '');
  const [loading, setLoading] = useState(!cachedCommodities);

  useEffect(() => {
    if (cachedCommodities) {
        setLoading(false);
        return;
    }

    const fetchCommodities = async () => {
      try {
        if (!commoditiesPromise) {
            commoditiesPromise = fetch(`${process.env.REACT_APP_URL_HEADER}/Common/getCommodities`)
                .then(res => res.text());
        }
        const data = await commoditiesPromise;
        cachedCommodities = data;
        setOptions(data);
      } catch (error) {
        console.error("Error fetching commodities:", error);
        commoditiesPromise = null;
      } finally {
        setLoading(false);
      }
    };
    fetchCommodities();
  }, []);

  return (
    <div>
      {loading ? (
        <Skeleton   width={100} height={40} />
      ) : (
        <select name="comm_id" id="comm_id" dangerouslySetInnerHTML={{ __html: options }} />
      )}
    </div>
  );
};

const GetCommodities = () => {
  return (
    <>
      <GetCommOpt />
    </>
  );
}

export default GetCommodities;